














import { Vue, Component, Prop } from 'vue-property-decorator';
import { Competency } from '@/models/competency/competency';

@Component({
  name: 'GExamCreateConfirmViewCompetency',
  computed: {},
  methods: {},
})
export default class GExamCreateConfirmViewCompetency extends Vue {
  @Prop() title: string;
  @Prop() competencies: Competency[];
  mounted() {}
}
